import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { authInfo } from '../../actions'
import { uploadImage } from '../../lib/upload'
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
const _ = require('lodash');

const propTypes = {
  dispatch: PropTypes.func,
  salesChannel: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  catalogs: PropTypes.any,
  settings: PropTypes.any,
  globalSettings: PropTypes.any,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}


const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
class EditSalesChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      alertOpen: false,
      alertMessage: '',
      settings: {
        clientLogo: '',
        heroImg: {
          desktop: '',
          mobile: '',
        },
        showNavbar: true,
        showHero: true,
        showFooter: true,
        theme: 'default',
        layout: 'default',
        seoName: '',
        seoDescription: '',
        seoTitle: '',
      },
      required: {
        name: null,
        displayName: null,
        subdomain: null,
      },
      globalSettings: {
      },
      salesChannel: {
        name: '',
        displayName: '',
        catalogId: 0,
        disabled: false,
        subdomain: '',
        campaignId: '',
        startDate: '',
        endDate: '',
        debugMode: false,
        giftCard: false,
        pickPack: false,
        showPromo: true
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let salesChannel;
    if (nextProps.salesChannel.id) {
      salesChannel = nextProps.salesChannel;
    } else {
      salesChannel = nextProps.salesChannel[0];
    }
    salesChannel.startDate = (salesChannel.startDate === null) ? '' : salesChannel.startDate;
    salesChannel.endDate = (salesChannel.endDate === null) ? '' : salesChannel.endDate;
    this.setState({
      salesChannel,
      settings: nextProps.settings,
      globalSettings: nextProps.globalSettings,
    });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, salesChannel } = this.state;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = salesChannel[paramName];
      required[paramName] = (param === null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDatePickerChange(e, date, target) {
    const { salesChannel } = this.state;
    _.set(salesChannel, target, date);
    this.setState({
      salesChannel,
      edited: true,
    });
  }

  handleSelectChange(event, index, value, target, parent) {
    const nextState = this.state;
    _.set(nextState[parent], target, value);
    nextState.edited = true;
    this.setState({ nextState });
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state;
    switch (e.target.type) {
      case ('checkbox'):
        _.set(nextState, e.target.name, e.target.checked);
        break;
      default:
        _.set(nextState, e.target.name, e.target.value);
        break;
    }
    nextState.edited = true;
    this.setState(nextState);
    this.setRequiredParams();
  }
  handleUploadedImage(name, value) {
    console.log('name, value ', name, value)
    const nextState= this.state
    _.set(nextState, name, value)
    nextState.edited = true
    this.setState({
      nextState,
    })
    console.log('settings in state', this.state.settings)
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/saleschannels/view/${this.state.salesChannel.id}`);
    }
  }
  clearDates() {
    const { salesChannel } = this.state;
    salesChannel.startDate = salesChannel.endDate = '';
    this.setState({ salesChannel });
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/saleschannels/view/${this.state.salesChannel.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Sales Channel Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this sales channel?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    const { salesChannel } = this.state;
    // Required because Swagger 2 does not support nullable values
    salesChannel.catalogId = (salesChannel.catalogId === null) ? 0 : salesChannel.catalogId;
    this.setState({ salesChannel });
    this.props.onSave(this.state.salesChannel);

    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.salesChannel.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(salesChannel);
        break;
      default:
        this.props.onSave(salesChannel);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/saleschannels?page=1');
  }
  onDrop(file, bucket, name) {
    const { dispatch } = this.props
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        this.handleChange({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        alert(`Image upload failed: ${er}`);
        return '';
      });
  }
  render() {
    const layoutSettings = (this.state.settings.useGlobalLayout) ? this.state.globalSettings : this.state.settings;
    const seoSettings = (this.state.settings.useGlobalSeo) ? this.state.globalSettings : this.state.settings;
    const catalogSelect = _.map(this.props.catalogs, c => <MenuItem value={c.id} key={c.id} primaryText={c.name} />);
    const autoOk = true;
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
      inline: {
        display: 'flex',
        width: '100%',
      },
      inlineBlock: {
        display: 'inline-block',
        width: '50%',
      },
      passcodeUl: {
        display: 'inline-block',
        width: '33%',
        paddingTop: '30px',
      },
      radioButton: {
        marginBottom: 16,
        float: 'left',
        display: 'inline-block',
      },
    };
    return (
      <div style={{ width: '100%' }}>
        <h2>Edit Sales Channel</h2>
        <div className="content">
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="View"
              primary
              onClick={this.navigateToView}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <div style={{ marginBottom: '15px' }}>
            <TextField
              floatingLabelText="ID"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.salesChannel.id}
              disabled
            />
            <br />
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="salesChannel.name"
              onChange={(event) => this.handleChange(event)}
              style={styles.inputStyle}
              value={this.state.salesChannel.name || ''}
              errorStyle={{ color: cyan500 }}
              errorText={this.state.required.name}
            />
            <TextField
              floatingLabelText="Display Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="salesChannel.displayName"
              onChange={(event) => this.handleChange(event)}
              style={styles.inputStyle}
              value={this.state.salesChannel.displayName || ''}
              errorStyle={{ color: cyan500 }}
              errorText={this.state.required.displayName}
            />
            <TextField
              floatingLabelText="Subdomain"
              floatingLabelStyle={styles.floatingLabelStyle}
              name="salesChannel.subdomain"
              onChange={(event) => this.handleChange(event)}
              style={styles.inputStyle}
              value={this.state.salesChannel.subdomain}
              errorText={this.state.required.subdomain}
              errorStyle={{ color: cyan500 }}
            />
          </div>
          <SelectField
            value={this.state.salesChannel.catalogId}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'catalogId', 'salesChannel')}
            floatingLabelText="Catalog"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="catalogId"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed
          >
            <MenuItem value={0} key={0} primaryText="None" />
            {catalogSelect}
          </SelectField>
          <TextField
            floatingLabelText="Activa Campaign Id"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="salesChannel.campaignId"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            value={this.state.salesChannel.campaignId || ''}
            errorText={this.state.campaignId}
            errorStyle={{ color: cyan500 }}
          />
          <div id="datePickerWrapper">
            <DatePicker
              floatingLabelText="Start Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="Start Date"
              value={(this.state.salesChannel.startDate) ? new Date(this.state.salesChannel.startDate) : ''}
              autoOk={autoOk}
              name="startDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'startDate')}
              style={styles.datePickerStyle}
            />
            <DatePicker
              floatingLabelText="End Date"
              mode="landscape"
              floatingLabelStyle={styles.floatingLabelStyle}
              hintText="End Date"
              value={(this.state.salesChannel.endDate) ? new Date(this.state.salesChannel.endDate) : ''}
              autoOk={autoOk}
              name="endDate"
              onChange={(e, date) => this.handleDatePickerChange(e, date, 'endDate')}
              style={styles.datePickerStyle}
            />
            <div style={{ width: '50px', display: 'inline-block', marginTop: '23px' }}>
              <IconButton
                tooltip="Clear Dates"
                onClick={this.clearDates}
              >
                <FontIcon className="fa fa-trash" />
              </IconButton>
            </div>
          </div>
          <br />
          <br />
          <div className="optionsDiv">
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Disabled"
                  name="salesChannel.disabled"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '100px' }}
                  defaultChecked={this.state.salesChannel.disabled}
                />
              </li>
              <li>
                <Checkbox
                  label="Debug Mode"
                  name="salesChannel.debugMode"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '130px' }}
                  defaultChecked={this.state.salesChannel.debugMode}
                />
              </li>
            </ul>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Show Gift Card Product"
                  name="giftCard"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  defaultChecked={this.state.salesChannel.giftCard}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Pick-Pack Products"
                  name="pickPack"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  defaultChecked={this.state.salesChannel.pickPack}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Promo Ribbon"
                  name="salesChannel.showPromo"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '100px' }}
                  defaultChecked={this.state.salesChannel.showPromo}
                />
              </li>
            </ul>
          </div>
        </div>
        <br />
        <br />
        <br />
        <h2>Layout Options</h2>
        <div className="content">
          <Checkbox
            label="Use Global Layout"
            name="settings.useGlobalLayout"
            onCheck={(event) => this.handleChange(event)}
            labelStyle={{ marginLeft: '-12px', width: '200px' }}
            defaultChecked={this.state.settings.useGlobalLayout}
          />
          <br />
          <TextField
            value={layoutSettings.clientLogo || ''}
            floatingLabelText="Client Logo URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="clientLogo"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalLayout}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'settings.clientLogo'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Client Logo Image</p>
          </button>
          <br />
          <br />
          <TextField
            value={layoutSettings.heroImg.desktop || ''}
            floatingLabelText="Desktop Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="heroImg.desktop"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalLayout}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'settings.heroImg.desktop'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Desktop Hero Image</p>
          </button>
          <br />
          <br />
          <TextField
            value={layoutSettings.heroImg.mobile || ''}
            floatingLabelText="Mobile Hero Image URL"
            floatingLabelStyle={styles.floatingLabelStyle}
            name="heroImg.mobile"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalLayout}
          />
          <button
            className="filestack-button"
            onClick={(e) => {
              e.preventDefault;
              return client.picker({
                uploadInBackground: false,
                onUploadDone: ((res) => {
                  console.log('RES From filestack', res);
                  const targetName = 'settings.heroImg.mobile'
                  const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                  this.handleUploadedImage(targetName, targetValue)
                })
              }).open()
            }}
            style={dropzoneStyles}>
            <p className="filestack-uplaod">Upload Mobile Hero Image</p>
          </button>
          <br />
          <br />
          <SelectField
            value={layoutSettings.layout}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'layout', 'settings')} // eslint-disable-line max-len
            floatingLabelText="Display Template"
            style={{ marginTop: '-25px', float: 'left', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="layout"
            floatingLabelStyle={styles.floatingLabelStyle}
            disabled={this.state.settings.useGlobalLayout}
          >
            <MenuItem value="default" primaryText="Default" />
            <MenuItem value="variation-2" primaryText="Variation-2" />
            <MenuItem value="variation-3" primaryText="Variation-3" />
          </SelectField>
          <SelectField
            value={layoutSettings.theme}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'theme', 'settings')} // eslint-disable-line max-len
            floatingLabelText="Display Theme"
            style={{ marginTop: '-25px', float: 'left', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="theme"
            floatingLabelStyle={styles.floatingLabelStyle}
            disabled={this.state.settings.useGlobalLayout}
          >
            <MenuItem value="default" primaryText="Default" />
            <MenuItem value="variation-2" primaryText="Variation-2" />
            <MenuItem value="variation-3" primaryText="Variation-3" />
          </SelectField>
          <br />
          <br />
          <br />
          <div style={{ height: '40px', marginTop: '10px' }}>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Show Navigation Bar"
                  name="settings.showNavbar"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  defaultChecked={layoutSettings.showNavbar}
                  disabled={this.state.settings.useGlobalLayout}
                  style={{ width: '200px' }}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Hero Image"
                  name="settings.showHero"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  defaultChecked={layoutSettings.showHero}
                  disabled={this.state.settings.useGlobalLayout}
                />
              </li>
              <li>
                <Checkbox
                  label="Show Footer"
                  name="settings.showFooter"
                  onCheck={(event) => this.handleChange(event)}
                  labelStyle={{ marginLeft: '-12px', width: '200px' }}
                  defaultChecked={layoutSettings.showFooter}
                  disabled={this.state.settings.useGlobalLayout}
                />
              </li>
            </ul>
          </div>
        </div>
        <h2>SEO Options</h2>
        <div className="content">
          <Checkbox
            label="Use Global SEO"
            name="settings.useGlobalSeo"
            labelStyle={{ marginLeft: '-12px', width: '200px' }}
            defaultChecked={this.state.settings.useGlobalSeo}
            onCheck={(event) => this.handleChange(event)}
          />
          <br />
          <TextField
            floatingLabelText="SEO Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoName || ''}
            name="settings.seoName"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalSeo}
          />
          <TextField
            floatingLabelText="SEO Title"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoTitle || ''}
            name="settings.seoTitle"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalSeo}
          />
          <TextField
            floatingLabelText="SEO Description"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={seoSettings.seoDescription || ''}
            name="settings.seoDescription"
            onChange={(event) => this.handleChange(event)}
            style={styles.inputStyle}
            disabled={this.state.settings.useGlobalSeo}
            multiLine={true}
          />
        </div>
        <br />
      </div>

    );
  }
}

EditSalesChannel.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditSalesChannel.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    salesChannel: state.salesChannels.salesChannel,
    catalogs: state.catalogs.results,
    settings: state.settings.data,
    globalSettings: state.globalSettings.data,
  };
}

export default connect(mapStateToProps)(EditSalesChannel);



// WEBPACK FOOTER //
// ./src/components/salesChannels/EditSalesChannel.js